/**
 * 犬種ID → 表示名。
 *
 * 正はジェネレーターの `frontend-generate-clothing-pattern/lib/pattern/`
 * （breed-catalog.ts の ja / breeds.ts の label）。ダッシュボードの犬種ランキング表示にのみ使う。
 * ジェネレーター側に犬種が追加されてここが古くなっても、未知のIDはそのまま表示するので壊れない。
 */
const BREED_LABELS: Record<string, string> = {
  affenpinscher: 'アーフェンピンシャー',
  afghan_hound: 'アフガン・ハウンド',
  airedale_terrier: 'エアデール・テリア',
  akita: '秋田犬',
  alaskan_malamute: 'アラスカン・マラミュート',
  american_akita: 'アメリカン・アキタ',
  american_cocker_spaniel: 'アメリカン・コッカー・スパニエル',
  american_staffordshire_terrier: 'アメリカン・スタッフォードシャー・テリア',
  australian_cattle_dog: 'オーストラリアン・キャトル・ドッグ',
  australian_kelpie: 'オーストラリアン・ケルピー',
  australian_shepherd: 'オーストラリアン・シェパード',
  azawakh: 'アザワク',
  basenji: 'バセンジー',
  basset_hound: 'バセット・ハウンド',
  beagle: 'ビーグル',
  bearded_collie: 'ビアデッド・コリー',
  bedlington_terrier: 'ベドリントン・テリア',
  belgian_griffon: 'ベルジアン・グリフォン',
  belgian_groenendael: 'ベルジアン・シェパード・ドッグ・グローネンダール',
  belgian_malinois: 'ベルジアン・シェパード・ドッグ・マリノア',
  belgian_tervuren: 'ベルジアン・シェパード・ドッグ・タービュレン',
  bernese_mountain_dog: 'バーニーズ・マウンテン・ドッグ',
  bichon_frise: 'ビション・フリーゼ',
  bolognese: 'ボロニーズ',
  border_collie: 'ボーダー・コリー',
  border_terrier: 'ボーダー・テリア',
  borzoi: 'ボルゾイ',
  boston_terrier: 'ボストン・テリア',
  boxer: 'ボクサー',
  briard: 'ブリアード',
  brittany_spaniel: 'ブリタニー・スパニエル',
  brussels_griffon: 'ブリュッセル・グリフォン',
  bull_terrier: 'ブル・テリア',
  bulldog: 'ブルドッグ',
  bullmastiff: 'ブルマスティフ',
  cairn_terrier: 'ケアーン・テリア',
  cane_corso: 'イタリアン・コルソ・ドッグ',
  cardigan_welsh_corgi: 'ウェルシュ・コーギー・カーディガン',
  cavalier: 'キャバリア・キング・チャールズ・スパニエル',
  central_asian_shepherd: 'セントラル・アジア・シェパード・ドッグ',
  chihuahua: 'チワワ',
  chinese_crested: 'チャイニーズ・クレステッド・ドッグ',
  chow_chow: 'チャウ・チャウ',
  clumber_spaniel: 'クランバー・スパニエル',
  coton_de_tulear: 'コトン・ド・テュレアール',
  czechoslovakian_wolfdog: 'チェコスロバキアン・ウルフドッグ',
  dachshund: 'ミニチュアダックスフンド',
  dalmatian: 'ダルメシアン',
  dandie_dinmont_terrier: 'ダンディ・ディンモント・テリア',
  deerhound: 'ディアハウンド',
  dobermann: 'ドーベルマン',
  dogue_de_bordeaux: 'ボルドー・マスティフ',
  english_cocker_spaniel: 'イングリッシュ・コッカー・スパニエル',
  english_pointer: 'イングリッシュ・ポインター',
  english_setter: 'イングリッシュ・セター',
  english_springer_spaniel: 'イングリッシュ・スプリンガー・スパニエル',
  flat_coated_retriever: 'フラットコーテッド・レトリーバー',
  french_bulldog: 'フレンチブルドッグ',
  generic: 'その他・ミックス(標準体型)',
  german_hunting_terrier: 'ジャーマン・ハンティング・テリア',
  german_pinscher: 'ジャーマン・ピンシャー',
  german_shepherd: 'ジャーマン・シェパード・ドッグ',
  german_shorthaired_pointer: 'ジャーマン・ショートヘアード・ポインター',
  giant_schnauzer: 'ジャイアント・シュナウザー',
  golden_retriever: 'ゴールデン・レトリーバー',
  gordon_setter: 'ゴードン・セター',
  great_dane: 'グレート・デーン',
  great_pyrenees: 'グレート・ピレニーズ',
  greater_swiss_mountain_dog: 'グレート・スイス・マウンテン・ドッグ',
  greyhound: 'グレーハウンド',
  havanese: 'ハバニーズ',
  hokkaido_ken: '北海道犬',
  irish_setter: 'アイリッシュ・セター',
  irish_terrier: 'アイリッシュ・テリア',
  irish_water_spaniel: 'アイリッシュ・ウォーター・スパニエル',
  irish_wolfhound: 'アイリッシュ・ウルフハウンド',
  italian_greyhound: 'イタリアングレーハウンド',
  jack_russell_terrier: 'ジャック・ラッセル・テリア',
  japanese_chin: '狆(チン)',
  japanese_spitz: '日本スピッツ',
  japanese_terrier: '日本テリア',
  kai_ken: '甲斐犬',
  kaninchen_dachshund: 'カニーンヘン・ダックスフンド',
  keeshond: 'キースホンド',
  kerry_blue_terrier: 'ケリー・ブルー・テリア',
  kishu_ken: '紀州犬',
  kooikerhondje: 'コーイケルホンディエ',
  labrador_retriever: 'ラブラドール・レトリーバー',
  lagotto_romagnolo: 'ロマーニャ・ウォーター・ドッグ',
  lakeland_terrier: 'レークランド・テリア',
  lancashire_heeler: 'ランカシャー・ヒーラー',
  leonberger: 'レオンベルガー',
  lhasa_apso: 'ラサ・アプソ',
  maltese: 'マルチーズ',
  manchester_terrier: 'マンチェスター・テリア',
  mastiff: 'マスティフ',
  medium_poodle: 'ミディアム・プードル',
  miniature_american_shepherd: 'ミニチュア・アメリカン・シェパード',
  miniature_bull_terrier: 'ミニチュア・ブル・テリア',
  miniature_pinscher: 'ミニチュア・ピンシャー',
  miniature_poodle: 'ミニチュア・プードル',
  miniature_schnauzer: 'ミニチュア・シュナウザー',
  mudi: 'ムーディー',
  neapolitan_mastiff: 'ナポリタン・マスティフ',
  newfoundland: 'ニューファンドランド',
  norfolk_terrier: 'ノーフォーク・テリア',
  norwich_terrier: 'ノーリッチ・テリア',
  nova_scotia_duck_tolling_retriever: 'ノヴァ・スコシア・ダック・トーリング・レトリーバー',
  old_english_sheepdog: 'オールド・イングリッシュ・シープドッグ',
  papillon: 'パピヨン',
  parson_russell_terrier: 'パーソン・ラッセル・テリア',
  pekingese: 'ペキニーズ',
  pembroke_welsh_corgi: 'ウェルシュ・コーギー・ペンブローク',
  petit_basset_griffon_vendeen: 'プチ・バセット・グリフォン・バンデーン',
  petit_brabancon: 'プチ・ブラバンソン',
  polish_lowland_sheepdog: 'ポリッシュ・ローランド・シープドッグ',
  pomeranian: 'ポメラニアン',
  portuguese_water_dog: 'ポーチュギーズ・ウォーター・ドッグ',
  prazsky_krysarik: 'プラシュスキー・クリサジーク',
  presa_canario: 'プレサ・カナリオ',
  pug: 'パグ',
  pyrenean_sheepdog: 'ピレニアン・シープドッグ',
  rottweiler: 'ロットワイラー',
  rough_collie: 'ラフ・コリー',
  saint_bernard: 'セント・バーナード',
  saluki: 'サルーキ',
  samoyed: 'サモエド',
  schipperke: 'スキッパーキ',
  scottish_terrier: 'スコティッシュ・テリア',
  sealyham_terrier: 'シーリハム・テリア',
  shar_pei: 'シャー・ペイ',
  shetland_sheepdog: 'シェットランド・シープドッグ',
  shiba: '柴犬',
  shih_tzu: 'シーズー',
  shikoku_ken: '四国犬',
  siberian_husky: 'シベリアン・ハスキー',
  small_munsterlander: 'スモール・ミュンスターレンダー',
  staffordshire_bull_terrier: 'スタッフォードシャー・ブル・テリア',
  standard_dachshund: 'スタンダード・ダックスフンド',
  standard_poodle: 'スタンダード・プードル',
  standard_schnauzer: 'スタンダード・シュナウザー',
  taiwan_dog: 'タイワン・ドッグ',
  tibetan_spaniel: 'チベタン・スパニエル',
  tibetan_terrier: 'チベタン・テリア',
  tosa: '土佐犬',
  toy_manchester_terrier: 'トイ・マンチェスター・テリア',
  toy_poodle: 'トイプードル',
  vizsla: 'ショートヘアード・ハンガリアン・ビズラ',
  weimaraner: 'ワイマラナー',
  welsh_terrier: 'ウェルシュ・テリア',
  west_highland_white_terrier: 'ウエスト・ハイランド・ホワイト・テリア',
  wheaten_terrier: 'アイリッシュ・ソフトコーテッド・ウィートン・テリア',
  whippet: 'ウィペット',
  white_swiss_shepherd: 'ホワイト・スイス・シェパード・ドッグ',
  wire_fox_terrier: 'ワイアー・フォックス・テリア',
  yorkshire_terrier: 'ヨークシャー・テリア',
}

/** 未知のIDはそのまま返す（ジェネレーター側の追加に追随できていない場合の保険） */
export const breedLabel = (breedId: string): string => BREED_LABELS[breedId] ?? breedId
